/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, { useEffect, useState, useCallback } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBarcode, faBox, faCloudUploadAlt, faCode, faDollarSign, faEdit, faFlag, faHome, faHSquare, faImage, faPeopleArrows, faPlug, faQrcode, faRocket, faSearch, faTasks, faTrash, faUserShield } from "@fortawesome/free-solid-svg-icons"
import { Badge, Button, ButtonGroup, Card, Col, Dropdown, Form, Image, InputGroup, Pagination, ProgressBar, Row, Table } from '@themesberg/react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import _ from "lodash"

//import USAFlag from '../../assets/img/flags/united-states-of-america.svg';
import VietnamFlag from '../../assets/img/flags/vietnam.svg';
import ThailandFlag from '../../assets/img/flags/thailand.svg';
import ChinaFlag from '../../assets/img/flags/china.svg';

import PuPagination from "../../components/PuPagination"
import { Routes } from "../../routes"

import WaybillDetailPage from "./WaybillDetailPage"
import AppConfig from "../../core/config/AppConfig"
import { Link } from "react-router-dom"
import NewWaybillPage from "./NewWaybillPage"
import { getUser } from "../../core/auth/authentication"
import { nameFormat, phoneFormat } from "../../core/util/General"
import { faServicestack } from "@fortawesome/free-brands-svg-icons"
import { GetResultObject, PostRequest } from "../../core/API"
import { ApiSrc } from "../../resources/ApiSrc"
import Swal from 'sweetalert2'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const moment = require('moment');

export default (props) => {

  const [user, setUser] = useState()
  useEffect(()=> {
    getUser().then(it=>{
      setUser(it)
    })
  }, [])

  const dispatch = useDispatch();

  const waybillRes = useSelector((state) => state.waybill);
  //const waybills = _.get(waybillRes, "waybillList.data");
  const pages = _.get(waybillRes, "waybillList.pages");
  const size = _.get(waybillRes, "waybillList.size");
  const total = _.get(waybillRes, "waybillList.total");
  const [currentPage, setCurrentPage] = useState()

  const [accountNo, setAccountNo] = useState()
  const [barcode, setBarcode] = useState()
  const [countryCode, setCountryCode] = useState()
  const [serviceType, setServiceType] = useState()
  const [paid, setPaid] = useState()
  // const [id, setId] = useState('8a8083f17aa9d327017ac24c8c07339f')
  const [id, setId] = useState()
  const [reference, setReference] = useState()
  const [status, setStatus] = useState()

  const [isNew, setIsNew] = useState()
  const [photo, setPhoto] = useState()

  useEffect(() => {
    if (_.get(waybillRes, "waybillList.data") == undefined) {
      fetchData()
    }
  }, [])

  useEffect(() => {
    if(currentPage != undefined) fetchData()
  }, [currentPage])

  // enter to search
  const keyPressFunction = useCallback((event) => {
    if (event.keyCode === 13) {
      fetchData()
    }
  }, [props, status, accountNo, reference, barcode, countryCode, serviceType, paid]);

  useEffect(() => {
    document.addEventListener("keydown", keyPressFunction, false);

    return () => {
      document.removeEventListener("keydown", keyPressFunction, false);
    };
  }, [keyPressFunction]);

  const deleteWaybill = (item) => {
    PostRequest(ApiSrc.DELETE_WAYBILL, {
      token: "",
      input: {id: _.get(item, 'id')}
    }).then(result=>{
      GetResultObject(result, 'data', 200, (data) => {        
        dispatch(WaybillAction.deleteWaybillSuccess(data));                          
    }, error => {
      swal('error')
    })
    })
  }

  const fetchData = () => {
    dispatch(WaybillAction.getWaybillList({
      "input": {
        accountNo: accountNo ? `JOONAAK-${accountNo}` : undefined,
        barcode,
        reference,
        status,
        countryCode,
        serviceType,
        paid
      },
      "token": "string"
    }, {
      size: AppConfig.pageSize,
      sort: "createdAt,DESC",
      page: currentPage
    }));
  };

  if (id) {
    return <WaybillDetailPage id={id} onClose={(timer) => {
      dispatch(WaybillAction.clearWaybill())
      setId(undefined)
      clearInterval(timer)
    }} />
  }

  if (isNew) {
    return (
      <NewWaybillPage onClose={(timer) => {
        setIsNew(undefined)
        timer && clearInterval(timer)
      }} />
    )
  }

  return (
    <>
      {
        photo && (
          <Lightbox
            mainSrc={photo}
            // nextSrc={images[(photoIndex + 1) % images.length]}
            // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setPhoto(undefined)}
            // onMovePrevRequest={() =>
            //   this.setState({
            //     photoIndex: (photoIndex + images.length - 1) % images.length,
            //   })
            // }
            // onMoveNextRequest={() =>
            //   this.setState({
            //     photoIndex: (photoIndex + 1) % images.length,
            //   })
            // }
          />
        )
      }
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <div className="d-block mb-4 mb-md-0">
          <h4>Waybills</h4>
          <p className="mb-0"> </p>
        </div>
        <ButtonGroup>
          <Button variant="outline-primary" size="sm" onClick={() => { setIsNew(true) }}>New</Button>
          {
            _.get(user, 'role') == 'Super Admin' && (<Button variant="outline-primary" size="sm" as={Link} to={Routes.WaybillImport.path}>Import</Button>)
          }
          
        </ButtonGroup>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <Row>
            <Col xs={12} sm={6} xl={2}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    //console.log('>value', e.target.value)                        
                    setStatus(e.target.value == "--Select--" ? undefined : e.target.value)
                  }}>
                    <option>--Select--</option>
                    <option>Pending</option>
                    <option>Warehouse</option>
                    <option>Ready for Transit</option>
                    <option>Transit</option>
                    <option>Arrived</option>
                    <option>Received</option>
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Account No</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faUserShield} />
                  </InputGroup.Text>
                  <Form.Control required type="text" 
                    onChange={(e) => { setAccountNo(e.target.value == '' ? undefined : e.target.value) }} />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={3}>
              <Form.Group className="mb-4">
                <Form.Label>Reference#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faBox} />
                  </InputGroup.Text>
                  <Form.Control required type="text"
                    onChange={(e) => setReference(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={3}>
              <Form.Group className="mb-4">
                <Form.Label>Barcode#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faQrcode} />
                  </InputGroup.Text>
                  <Form.Control required type="text" 
                    onChange={(e) => setBarcode(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={2}>
              <Form.Group className="mb-4 float-end" style={{ paddingTop: 30 }}>
                <Button onClick={fetchData}><FontAwesomeIcon icon={faSearch} /> Search</Button>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} xl={3}>
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    //console.log('>value', e.target.value)                        
                    setCountryCode(e.target.value == "--Select--" ? undefined : e.target.value)
                  }}>
                    <option>--Select--</option>
                    <option value="86">China</option>
                    <option value="66">Thailand</option>
                    <option value="84">Vietnam</option>                    
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={6} xl={3}>
              <Form.Group className="mb-3">
                <Form.Label>Service Type</Form.Label>
                  <InputGroup>
                      <InputGroup.Text>
                          <FontAwesomeIcon icon={faServicestack} />
                      </InputGroup.Text>
                      <Form.Select onChange={(e) => {                                                
                          setServiceType(e.target.value == '' ? undefined : e.target.value)
                      }}>
                      <option value=''>--All--</option>
                      <option value={'pickup'}>Self Pickup</option>
                      <option value={'express'}>Express</option>
                      <option value={'joonaak'}>Jonnak Delivery</option>
                      </Form.Select>                
                  </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={6} xl={4}>
              <Form.Group className="mb-3">
                <Form.Label>Status Info</Form.Label>
                  <InputGroup>
                      <InputGroup.Text>
                          <FontAwesomeIcon icon={faDollarSign} />
                      </InputGroup.Text>
                      <Form.Select onChange={(e) => {                                                
                          setPaid(e.target.value == '' ? undefined : e.target.value)
                      }}>
                      <option value=''>--All--</option>
                      <option value={true}>Paid</option>
                      <option value={false}>Unpaid</option>                      
                      </Form.Select>                
                  </InputGroup>
              </Form.Group>
            </Col>
          
          </Row>
          
        </Card.Header>
        <Card.Body className="pb-0">
          <Table responsive className="table-centered table-nowrap rounded mb-0">
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">...</th>
                <th className="border-0">Create Time</th>
                <th className="border-0">Last Update Time</th>
                <th className="border-0">Reference#</th>
                <th className="border-0"></th>
                <th className="border-0">Account#</th>
                <th className="border-0">Status</th> 
                <th className="border-0">Status Info</th>                                
                <th className="border-0">Freight Fee($)</th>
                <th className="border-0">Volume(CMB)</th>
                <th className="border-0">Weight(kg)</th>
                <th className="border-0">Dimension(WHL)</th>
                
                {/* <th className="border-0">Warehouse Address</th> */}
              </tr>
            </thead>
            <tbody>
              {
                //receivers && receivers.map()
                _.get(waybillRes, 'waybillList.data') && _.get(waybillRes, 'waybillList.data').map((item, index) => {
                  console.log(">>item", item)
                  return (
                    <tr>
                      <td>{(index + 1) + (AppConfig.pageSize * (currentPage ?? 0))}</td>
                      <td>
                        <Button onClick={() => setId(item.id)} variant="transparent" size="sm" className="mb-0 fs-10"><FontAwesomeIcon icon={faEdit}/></Button>
                        {
                          (_.get(user, 'role') == 'Super Admin' && (_.get(item, 'status') == 'Pending' || _.get(item, 'status') == 'Warehouse')) && (
                            <Button onClick={()=>{
                                Swal.fire({
                                  title: 'Delete Waybill?',                                  
                                  showCancelButton: true,
                                  confirmButtonText: `Yes`,
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    deleteWaybill(item)
                                  }
                                })                               
                              }} 
                              variant="transparent" size="sm" className="mb-0 fs-10 text-danger"><FontAwesomeIcon icon={faTrash}/>
                              </Button>
                          )
                        }                        
                      </td>
                      <td>{moment(_.get(item, 'createdAt')).format('MM-DD-YYYY')}</td>
                      <td>{moment(_.get(item, 'updatedAt')).format('DD MM,YYYY HH:mm')}</td>

                      <td align="left">
                        <Image src={GetCountryFlag(_.get(item, 'countyCode'))} className="image-small me-2" />{_.get(item, 'reference', '')} 
                        <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{_.get(item, 'barcode', '')}</small>                        
                      </td>
                      <td>
                        {
                         _.get(item, 'photo') && (
                            <Button onClick={() => setPhoto(_.get(item, 'photo'))} variant="transparent" size="sm" className="mb-0 fs-10"><FontAwesomeIcon icon={faImage} /></Button> 
                         )
                        }                        
                      </td>
                      
                      <td>
                        {_.get(item, 'warehouse.accountNo', '')}
                        <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{ nameFormat(_.get(item, 'receiver')) }</small>
                        <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{ phoneFormat(_.get(item, 'receiver')) }</small>
                      </td>
                      <td align="center">
                        <WaybillStatus item={item} />                      
                      </td>

                      <td>
                        {
                          _.get(item, 'paid') && (
                            <label style={{color:'green', textDecoration: 'underline', textDecorationStyle: 'dotted'}}>paid</label>
                          )                          
                        }
                        <br/>
                        {
                          _.get(item, 'serviceType') && (
                            <small style={{color:'green', textDecoration: 'underline', textDecorationStyle: 'dotted', fontSize:8}}>{_.get(item, 'serviceType')}</small>
                          )
                        }
                      </td>
                      
                      
                      <td align="center">
                        {/* {
                          _.get(item, 'paid') && (<FontAwesomeIcon icon={faca} color={'green'}/>)
                        } */}
                        {_.get(item, 'freightFee', '')}
                      </td>
                      <td align="center">{_.get(item, 'volume', '')}</td>
                      <td align="center">{_.get(item, 'weight', '')}</td>
                      <td align="center">{_.get(item, 'width', '0.0')} {_.get(item, 'length', '0.0')} {_.get(item, 'height', '0.0')}</td>
                      {/* <td>
                                  <Image src={GetCountryFlag(_.get(item, 'countyCode'))} className="image-small me-2" />
                                  {_.get(item, 'warehouse.warehouse.note', '')}
                                </td>                                 */}
                      
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <PuPagination size={size} total={total} currentPage={currentPage} totalPage={pages} onChange={setCurrentPage} />
        </Card.Footer>
      </Card>
    </>
  )
}

const GetCountryFlag = (countryCode) => {
  console.log('> countryCode', countryCode)
  switch (countryCode) {
    case '86': return ChinaFlag
    case '84': return VietnamFlag
    case '66': return ThailandFlag
    default: return null
  }
}
//'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'

const WaybillStatusType = {
  PENDING: "Pending",
  RECEIVED: "Received",
  TRANSIT: "Transit",
  ARRIVED: "Arrived",
  WAREHOUSE: "Warehouse",
  WAREHOUSE_READY: "Warehouse Ready",
}

const WaybillStatus = ({ item }) => {
  switch (_.get(item, 'status')) {
    case WaybillStatusType.PENDING: return <Badge pill bg='warning' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    case WaybillStatusType.WAREHOUSE: return <Badge pill bg='secondary' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    case WaybillStatusType.TRANSIT:     
      if(_.get(item, 'status') == WaybillStatusType.TRANSIT && _.get(item, 'arrivedAt') != null) {
        return <>
        <FontAwesomeIcon className="text-warning" icon={faFlag} />&nbsp;
        <Badge pill bg='warning' className="badge-sm mb-0 fs-8">Arrived</Badge>
        </>        
      }        
      return <Badge pill bg='info' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    case WaybillStatusType.ARRIVED: return <Badge pill bg='success' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    case WaybillStatusType.RECEIVED: return <Badge pill bg='danger' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    default: return <Badge pill bg='danger' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
  }

}



export {
  WaybillStatusType, WaybillStatus, GetCountryFlag
}